import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import usePortal from '@hooks/usePortal';
import * as Styled from './BaseModalStyles';
import { BaseModalProps } from './BaseModalTypes';

function BaseModal({
  children,
  innerRef,
  innerWrapperRef,
  onClose,
  hOverlay,
  vAlignment,
  hAlignment,
  isOpen = true,
  isChildModal,
  backdrop,
  modalName,
  zIndex = 999,
}: BaseModalProps) {
  const portal = usePortal(modalName || 'host');

  /* eslint-disable consistent-return */
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('journey--overflowYHidden');
    }
    if (!isChildModal) {
      return () => {
        document.body.classList.remove('journey--overflowYHidden');
      };
    }
  }, [isOpen, isChildModal]);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('journey--overflowYHidden');
    }
  }, []);

  if (!portal || !isOpen) return null;

  return ReactDOM.createPortal(
    <Styled.Container zIndex={zIndex}>
      <Styled.Backdrop ref={innerRef} {...backdrop} />
      <Styled.Wrapper
        ref={innerWrapperRef}
        vAlignment={vAlignment}
        hAlignment={hAlignment}
      >
        {hOverlay && (
          <Styled.OutsideArea
            onClick={onClose as React.MouseEventHandler}
            data-testid="basemodal-outsidearea"
          />
        )}

        <Styled.Stage>{children}</Styled.Stage>
      </Styled.Wrapper>
    </Styled.Container>,
    portal,
  ) as React.ReactNode;
}

export default BaseModal;
